"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var colors_1 = require("../../colors");

var action_1 = require("./action");

var background_1 = require("./background");

var common_1 = require("./common");

var error_1 = require("./error");

var primary_1 = require("./primary");

var secondary_1 = require("./secondary");

var text_1 = require("./text");

var palette = {
  common: common_1["default"],
  primary: primary_1["default"],
  secondary: secondary_1["default"],
  error: error_1["default"],
  grey: colors_1.grey,
  text: text_1["default"],
  action: action_1["default"],
  background: background_1["default"],
  type: 'light' // Additional example configurations
  //
  // tslint:disable-next-line
  // See: github.com/mui-org/material-ui/blob/master/packages/material-ui/src/styles/createPalette.js
  //
  // tonalOffset: 0.2,
  // contrastThreshold: 3,
  // divider: 'rgba(0, 0, 0, 0.12)',
  // getContrastText: (background: string): string => '';

};
exports["default"] = palette;